import React, { useContext, useState, useRef } from "react";
import { CSSTransition } from "react-transition-group";
import { useTranslation } from "react-i18next";
import AppProgressInfo from "../appProgressInfo/appProgressInfo";
import ProgressBar from "../progressBar/progressBar";
import "./appHeader.scss";
import { SurveyContext } from "../../store/survey-context";

export default function AppHeader(props) {
  const [isHover, setIsHover] = useState(false);
  const headline = useRef();
  const context = useContext(SurveyContext);
  const { currentChapterNumber, toggleSurvey, survey } = context;
  const { currentChapterProgress } = props;
  const { t } = useTranslation(["common", "survey"]);

  if (survey?.isLastPage) return null;

  const currentChapterLabel = t(
    `survey.chapters.ch_${currentChapterNumber}.label`,
    { ns: "survey" }
  );
  const currentChapterName = t(
    `survey.chapters.ch_${currentChapterNumber}.name`,
    { ns: "survey" }
  );

  return (
    <button
      className="app-header"
      aria-label={t("progress.headline")}
      onClick={() => toggleSurvey(false)}
      onMouseEnter={() => setIsHover(true)}
      onMouseLeave={() => setIsHover(false)}
    >
      <div className="app-header__wrap">
        <CSSTransition
          nodeRef={headline}
          in={!isHover}
          timeout={300}
          classNames="fade"
          unmountOnExit
        >
          <div className="app-header__headline" ref={headline}>
            <div>
              <small className="app-header__chapter-label">
                {currentChapterLabel}
              </small>
              <span className="app-header__chapter-name text-uppercase">
                {currentChapterName}
              </span>
            </div>
          </div>
        </CSSTransition>
        <div className="app-header__status">
          <AppProgressInfo type="header" isHover={isHover} />
        </div>
      </div>
      <ProgressBar svg={true} progress={currentChapterProgress} />
    </button>
  );
}
